/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoPayoutAccountCreate } from '../../models/dto-payout-account-create';
import { PayoutAccountItem } from '../../models/payout-account-item';

export interface BookingControllerCreatePayoutAccount$Params {
      body: DtoPayoutAccountCreate
}

export function bookingControllerCreatePayoutAccount(http: HttpClient, rootUrl: string, params: BookingControllerCreatePayoutAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: PayoutAccountItem;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerCreatePayoutAccount.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: PayoutAccountItem;
      }>;
    })
  );
}

bookingControllerCreatePayoutAccount.PATH = '/booking/wallet/payout_accounts';
